"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.set = exports.get = void 0;
var available = false;
function initialize() {
    var test = 'test_string_nobody_will_use';
    try {
        sessionStorage.setItem(test, test);
        sessionStorage.removeItem(test);
        available = true;
    }
    catch (e) {
        available = false;
    }
}
initialize();
function get(key) {
    if (available) {
        var value = sessionStorage.getItem(key);
        if (!value) {
            return null;
        }
        try {
            return JSON.parse(value);
        }
        catch (e) {
            console.warn(e);
        }
    }
    return null;
}
exports.get = get;
function set(key, value) {
    if (available) {
        sessionStorage.setItem(key, JSON.stringify(value));
        return;
    }
}
exports.set = set;
function remove(key) {
    if (available) {
        sessionStorage.removeItem(key);
        return;
    }
}
exports.remove = remove;
